import {
  AscHelpContainer,
  AscReleaseNotesContainer,
  AscTermsAndConditionsContainer,
  AscUserProfileContainer,
} from './containers'
import Index from './Index'

const userRouter = {
  path: '/user',
  component: Index,
  meta: {},
  children: [
    {
      path: 'help',
      name: 'Help & About',
      component: AscHelpContainer,
      meta: {
        breadcrumbs: [
          {
            text: 'Home',
            to: '/',
          },
          {
            text: 'Help & About',
          },
        ],
      },
    },
    {
      path: 'release-notes',
      name: 'Release Notes',
      component: AscReleaseNotesContainer,
      meta: {
        breadcrumbs: [
          {
            text: 'Home',
            to: '/',
          },
          {
            text: 'Release Notes',
          },
        ],
      },
    },
    {
      path: 'terms',
      name: 'Terms & Conditions',
      component: AscTermsAndConditionsContainer,
      meta: {
        breadcrumbs: [
          {
            text: 'Home',
            to: '/',
          },
          {
            text: 'Terms & Conditions',
          },
        ],
      },
    },
    {
      path: 'profile',
      name: 'User Profile',
      component: AscUserProfileContainer,
      meta: {
        breadcrumbs: [
          {
            text: 'Home',
            to: '/',
          },
          {
            text: 'User Profile',
          },
        ],
      },
    },
  ],
}

export default userRouter
